import { useIntl } from 'react-intl';
import { Descriptions, Skeleton } from 'antd';

import { Consumable } from '@/core/domain/operational/Consumables/Consumables.types';

interface ConsumableDetailsDescriptionProps {
  consumable?: Consumable;
  isLoading: boolean;
}

function ConsumableDetailsDescription({
  consumable,
  isLoading,
}: ConsumableDetailsDescriptionProps) {
  const intl = useIntl();

  return (
    <Skeleton active loading={isLoading}>
      <Descriptions title={consumable?.name} column={{ xs: 1, xxl: 3 }}>
        <Descriptions.Item
          label={intl.formatMessage({ id: 'consumables.entity.subGroup' })}
        >
          {consumable?.subGroup?.name}
        </Descriptions.Item>
        <Descriptions.Item
          label={intl.formatMessage({ id: 'consumables.entity.manufacturer' })}
        >
          {consumable?.manufacturer.name}
        </Descriptions.Item>
        <Descriptions.Item
          label={intl.formatMessage({ id: 'consumables.entity.unit' })}
        >
          {consumable?.unit}
        </Descriptions.Item>
      </Descriptions>
    </Skeleton>
  );
}

export default ConsumableDetailsDescription;
